const ChoiceInput = ({
  className,
  choice,
  onClick,
  disabled,
  isMultipleChoice,
}) => {
  return (
    <div
      id={`choice-${choice}`}
      onClick={() => (!disabled ? onClick?.() : {})}
      className={`w-3 h-3 flex justify-center border border-primary ${
        isMultipleChoice ? 'rounded-[3px]' : 'rounded-full'
      }  items-center  text-over-secondary-background  text-dark p-2.5 
       ${className} ${disabled ? '' : 'cursor-pointer'}`}
    >
      <span className="text-sm font-bold">{choice}</span>
    </div>
  )
}

export default ChoiceInput
